import type { WalletMonitoringItem } from '@shared/api/contracts';
import type { WalletKind } from '../model/types';

export const WALLET_KIND_ORDER: WalletKind[] = [
  'deposit',
  'working',
  'payout',
  'service',
  'other',
];

export const WALLET_KIND_LABEL_KEYS: Record<WalletKind, string> = {
  deposit: 'wallets.kinds.deposit',
  working: 'wallets.kinds.working',
  payout: 'wallets.kinds.payout',
  service: 'wallets.kinds.service',
  other: 'wallets.kinds.other',
};

export const displayWalletKind = (kind: WalletMonitoringItem['kind']): WalletKind =>
  kind ?? 'other';
